var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 893,
    height: 727,
    viewBox: "0 0 893 727",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M357.243 167.268L306.832 196.33L187.836 127.295L240.072 98.2334L357.243 167.268Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M357.243 320.769L306.832 349.839L187.836 280.804L240.072 251.742L357.243 320.769Z",
    stroke: "#231F20",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M356.95 320.769L306.539 349.839L187.551 280.804L239.779 251.742L356.95 320.769Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M306.828 196.33V349.839",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240.52 98.2334V251.743L187.887 280.759V127.249",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M357.242 166.757V320.266",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M780.359 536.327L620.145 628.697L241.992 409.314L407.978 316.937L780.359 536.327Z",
    fill: "#C1282D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.891 223.987L206.48 253.049L87.4844 184.021L139.713 154.952L256.891 223.987Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.891 377.496L206.48 406.558L87.4844 337.523L139.713 308.461L256.891 377.496Z",
    stroke: "#231F20",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.598 377.496L206.187 406.558L87.1992 337.523L139.428 308.461L256.598 377.496Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.477 253.049V406.558",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.168 154.952V308.461L87.5352 337.477V183.968",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.891 223.482V376.992",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M678.669 244.015L628.257 273.084L509.262 204.049L561.49 174.987L678.669 244.015Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M678.669 397.523L628.257 426.593L509.262 357.558L561.49 328.496L678.669 397.523Z",
    stroke: "#231F20",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M678.376 397.523L627.965 426.593L508.977 357.558L561.205 328.496L678.376 397.523Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M628.254 273.084V426.593",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M561.946 174.987V328.497L509.312 357.512V204.003",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M678.668 243.511V397.02",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M834.883 330.627L784.472 359.696L665.477 290.661L717.705 261.592L834.883 330.627Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.883 484.135L784.472 513.205L665.477 444.17L717.705 415.101L834.883 484.135Z",
    stroke: "#231F20",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.591 484.135L784.179 513.205L665.191 444.17L717.42 415.101L834.591 484.135Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.469 359.695V513.205",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.161 261.592V415.101L665.527 444.117V290.608",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.883 330.122V483.631",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M398.23 140.199L448.642 169.261L567.637 100.233L515.409 71.1641L398.23 140.199Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M398.23 293.708L448.642 322.769L567.637 253.742L515.409 224.673L398.23 293.708Z",
    stroke: "#231F20",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M398.52 293.708L448.931 322.769L567.919 253.742L515.69 224.673L398.52 293.708Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M448.641 169.261V322.77",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M514.949 71.1641V224.673L567.582 253.689V100.18",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M398.23 139.694V293.204",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.285 71.0349L337.696 100.097L456.684 31.0693L404.456 2L287.285 71.0349Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.285 224.544L337.696 253.605L456.684 184.57L404.456 155.509L287.285 224.544Z",
    stroke: "#231F20",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.57 224.544L337.982 253.605L456.977 184.57L404.749 155.509L287.57 224.544Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.004 2V155.509L456.637 184.525V31.0159",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.285 224.032V70.5303L337.696 100.096V253.605",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.805 542.542L456.216 571.603L575.204 502.576L522.975 473.507L405.805 542.542Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.805 696.051L456.216 725.112L575.204 656.077L522.975 627.016L405.805 696.051Z",
    stroke: "#231F20",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.094 696.051L456.505 725.112L575.493 656.077L523.264 627.016L406.094 696.051Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.215 571.604V725.113",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.523 473.507V627.016L575.157 656.032V502.523",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.805 542.037V695.539",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M306.828 473.691L357.239 502.761L476.227 433.726L423.999 404.664L306.828 473.691Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M306.828 627.2L357.239 656.269L476.227 587.234L423.999 558.165L306.828 627.2Z",
    stroke: "#231F20",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M307.113 627.2L357.532 656.269L476.52 587.234L424.292 558.165L307.113 627.2Z",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M357.238 502.761V656.27",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M423.547 404.664V558.166L476.18 587.182V433.68",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M306.828 473.188V626.697",
    stroke: "white",
    strokeWidth: 2.33654,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M127.086 409.244V536.715",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M136.418 397.416V538.448",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M141.094 420.438V507.226",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M145.758 427.402V497.926",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M131.715 420.47V520.819",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M103.746 422.768V550.247",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M108.375 433.999V534.348",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.43 431.694V490.009",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M113.039 438.069V524.857",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M117.711 442.705V513.221",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M122.375 443.491V501.805",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M159.77 445.668V466.01",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M164.434 426.271V476.553",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M169.102 422.202V472.484",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M155.055 443.339V471.813",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M173.773 421.638V471.919",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M183.113 414.146V471.163",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M187.777 400.54V475.126",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M192.445 394.171V482.318",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M178.398 430.938V459.42",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M197.117 403.885V481.182",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M206.457 391.461V467.399",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M211.121 378.495V473.423",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M215.785 394.95V451.966",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M201.742 417.278V449.57",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M220.457 392.675V449.691",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M229.797 386.528V443.537",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M234.461 400.158V428.64",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M239.129 384.245V441.261",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M225.086 403.067V435.359",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M244.969 380.855V437.872",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M254.309 374.708V431.717",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M258.973 371.204V428.22",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M263.637 378.633V418.805",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M249.598 390.079V422.371",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M268.312 376.465V416.637",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M277.652 370.959V411.131",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M282.316 372.128V401.174",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M286.98 362.032V407.885",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M272.941 381.794V404.549",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M291.656 363.293V403.465",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M300.992 357.795V397.967",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M305.656 359.307V383.543",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M310.324 349.64V384.077",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M296.281 368.63V391.384",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M314.996 354.222V381.168",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M324.336 349.678V383.397",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M329 349.373V368.462",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M333.664 343.897V366.621",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M319.621 358.772V377.869",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M338.34 342.065V364.782",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M347.676 334.751V368.631",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M352.344 334.751V368.631",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M357.016 329.413V351.389",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M342.965 343.89V363.071",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M361.68 324.404V357.024",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M366.348 319.731V352.351",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M371.02 319.425V352.045",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M375.688 321.953V345.005",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M385.023 320.41V335.323",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M389.691 309.178V341.729",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M394.363 298.144V348.425",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M398.988 307.483V333.155",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M403.703 293.471V343.752",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M380.312 317.096V345.569",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M776.355 472.958V594.855",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M767.02 459.206V594.076",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M762.352 485.533V568.526",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M757.68 489.817V557.249",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M771.73 483.587V579.553",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M799.699 487.869V609.766",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M795.074 495.002V590.968",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M753.016 493.055V548.819",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M790.398 501.225V584.218",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M785.734 505.509V572.94",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M781.066 508.747V564.511",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M743.676 504.341V523.789",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M739.008 489.038V537.12",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M734.336 486.312V534.395",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M748.391 504.341V531.57",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M729.672 483.587V531.669",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M720.332 475.462V529.981",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M715.668 461.282V532.608",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M710.992 453.112V537.403",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M725.047 490.199V517.436",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M706.328 455.709V529.623",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M696.992 450.523V523.14",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M692.324 437.161V527.943",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M687.652 456.044V510.563",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M701.703 473.996V504.875",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M682.988 452.799V507.318",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M673.648 446.919V501.438",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M668.984 462.191V489.428",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M664.312 442.506V497.025",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M678.359 461.626V492.505",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M658.477 433.687V488.206",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M649.137 427.8V482.327",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M644.469 427.8V482.327",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M639.797 431.556V469.971",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M653.848 442.506V473.385",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M504.414 334.322V408.244",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M495.078 327.97V400.593",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M490.41 318.112V408.894",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M485.738 334.658V389.185",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M499.781 354.947V385.826",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M481.074 331.421V385.94",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M471.734 324.365V378.892",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M467.062 336.14V363.376",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M462.395 319.96V374.479",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M476.438 339.072V369.951",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M456.566 318.135V372.654",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M447.23 308.751V363.278",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M442.555 308.751V363.278",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M437.887 312.508V350.923",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M451.93 325.793V356.672",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M635.133 429.487V467.903",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M625.793 425.341V463.756",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M621.129 425.341V453.112",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M616.457 416.804V460.648",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M630.504 435.703V457.457",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M611.789 419.125V457.54",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M602.453 414.979V453.394",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M597.789 413.078V436.253",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M593.113 403.831V436.764",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M607.16 425.341V447.095",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M588.449 408.214V433.985",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M579.109 403.869V436.115",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M574.445 403.579V421.829",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M569.773 398.34V420.071",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M583.82 412.566V430.831",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M565.105 396.585V418.316",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M555.77 389.599V421.989",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M551.102 382.597V414.988",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M546.43 385.658V406.672",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M560.477 398.333V416.682",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M541.762 377.571V408.763",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M537.09 375.234V406.426",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M532.426 372.708V403.908",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M527.758 374.006V396.05",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M518.422 372.578V386.849",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M513.746 359.612V390.736",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M509.082 349.105V397.188",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M523.125 369.21V396.439",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M131.715 151.08L891.526 601.781",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "5.79 5.79"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M409.498 315.845L1 542.97",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "5.79 5.79"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M868.185 119.766L459.68 346.891",
    stroke: "#C1282D",
    strokeWidth: 1.74859,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "5.79 5.79"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.a679bbf12cf1b119cc30321c6a600527.svg";
export { ForwardRef as ReactComponent };